// Lógica de verificación/refresh de token, extraída del store para poder testearla
// sin montar Vue/Vuex. La consume store/index.js (verifyToken).
//
// Fix Jun 2026: refresh proactivo (buffer) + manejo correcto de fallo (redirect a Login)
// + guard contra errores sin estructura. Resuelve el "dropdown vacío silencioso" por 401.

export const REFRESH_BUFFER_MS = 2 * 60 * 1000 // refrescar 2 min ANTES de que expire el access token

// ¿Hay que refrescar el access token? Proactivo: true si ya expiró o si le quedan < buffer.
export function needsRefresh(endDateEpochSec, nowMs, bufferMs = REFRESH_BUFFER_MS) {
  if (!endDateEpochSec) return false
  return endDateEpochSec * 1000 - bufferMs < nowMs
}

// Flujo completo de verifyToken con dependencias inyectadas (testeable).
// deps = { state, commit, axiosC, router, now?, bufferMs? }
// Devuelve { state: boolean, message: string }. state=false => la sesión no es válida
// (el caller NO debe continuar; ya se redirige a Login).
export async function runVerifyToken(deps) {
  const { state, commit, axiosC, router } = deps
  const now = deps.now != null ? deps.now : Date.now()
  const bufferMs = deps.bufferMs != null ? deps.bufferMs : REFRESH_BUFFER_MS
  const res = { state: true, message: '' }

  if (!state.endDate) {
    res.state = false
    res.message = `Verify token: Can't get access token.`
    return res
  }

  if (needsRefresh(state.endDate, now, bufferMs)) {
    try {
      const response = await axiosC.post('auth/refresh/')
      commit('setAccessToken', response.data)
    } catch (err) {
      // Refresh falló (refresh token vencido, >12h, o sin respuesta del server).
      res.state = false
      const msg = err && err.response && err.response.data && err.response.data.message
      res.message = (msg && msg.mensaje) ? msg.mensaje : 'Sesión expirada, vuelve a iniciar sesión.'
      commit('setDestroyTokens')
      if (router && router.push) router.push({ name: 'Login' })
    }
  }
  return res
}
